import { Record } from 'immutable';
import TransactionSummarySectionModel from 'commons-vehicle/PurchaseMethodsV25/models/TransactionSummarySectionModel.js';

const CashPurchaseOptionsModelV25Record = Record({
    transaction: [new TransactionSummarySectionModel()],
    incentives: {
        effectiveIncentiveProgram: 0,
        manufacturerRebates: 0,
        governmentRebates: 0,
        dealerRebates: 0,
        total: 0,
        deliveryBonus: 0,
        electricRebateIncluded: false,
    },
    baseSellingPrice: 0,
    disclaimer: '',
});

class CashPurchaseOptionsModelV25 extends CashPurchaseOptionsModelV25Record {}

export default CashPurchaseOptionsModelV25;
